module.exports = __webpack_public_path__ + "static/luthgrandroundflier-d9b451008196cef7eecc4c01e7e8a3f1.jpg";